import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1008"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.292 9.297a.7.7 0 0 0-.7.7v3.155H2.398v-3.087c0-.384-.316-.7-.7-.7s-.7.316-.7.7v3.787a.7.7 0 0 0 .7.7h12.594a.7.7 0 0 0 .7-.7V9.997a.7.7 0 0 0-.7-.7z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M3.807 7.043h2.981l-1.49 2.582a.701.701 0 0 0 1.213.701L8 7.744l1.49 2.581a.7.7 0 0 0 .956.256.701.701 0 0 0 .257-.957l-1.49-2.582h2.981a.7.7 0 1 0 0-1.4h-2.98l1.49-2.581a.701.701 0 0 0-1.214-.7L8 4.943 6.51 2.361a.701.701 0 0 0-1.213.701l1.49 2.581h-2.98a.7.7 0 1 0 0 1.4z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }